var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Delete",
    "data-name": "Iconly/Bold/Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 15,
    viewBox: "0 0 13.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42192",
    "data-name": "Path 42192",
    d: "M11.954,5.023a.544.544,0,0,1,.392.175.559.559,0,0,1,.136.418c0,.051-.4,5.106-.628,7.234a2.188,2.188,0,0,1-2.247,2.12c-.971.022-1.92.029-2.854.029-.992,0-1.962-.008-2.9-.029a2.187,2.187,0,0,1-2.2-2.12c-.235-2.135-.627-7.183-.635-7.234A.593.593,0,0,1,1.159,5.2a.53.53,0,0,1,.392-.175ZM8.3,0A1.49,1.49,0,0,1,9.725,1.123h0l.123.547a.96.96,0,0,0,.931.762h2.187a.542.542,0,0,1,.535.55h0v.285a.547.547,0,0,1-.535.55H.535A.547.547,0,0,1,0,3.268H0V2.983a.542.542,0,0,1,.535-.55H2.722a.962.962,0,0,0,.931-.761h0l.115-.511A1.491,1.491,0,0,1,5.2,0H8.3Z",
    transform: "translate(0 0)",
    fill: "#ff5455"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDelete);
export default __webpack_public_path__ + "static/media/CartDelete.64351ed2484d7e0b352b024a25fcad56.svg";
export { ForwardRef as ReactComponent };